import { Map } from 'common/utils/Map';
import { Params } from './types';

import {
  checkIsGoogleMap,
  checkIsHereMap
} from 'entities/map';

import { GoogleRoute } from './GoogleRoute';
import { HereRoute } from './HereRoute';

export const routeFactory = (map: Map, params: Params) => {
  if (checkIsGoogleMap(map.name)) {
    return new GoogleRoute(map, params);
  }

  if (checkIsHereMap(map.name)) {
    return new HereRoute(map, params);
  }

  throw Error('There is no a route for such a map');
};
